import { Button, Modal } from "antd";
import styles from "../../../styles/Components/new-insight/watchlist/WatchlistReplacedModal.module.css";

function coinLogo(symbol) {
  return `https://cryptocrispypro.s3.ap-southeast-2.amazonaws.com/symbol_icons/${symbol}.png`;
}

function WatchlistReplacedModal({ open, coins = [], onClose }) {
  const list = Array.isArray(coins) ? coins.filter((coin) => coin?.symbol) : [];
  return (
    <Modal
      open={open}
      title="Your watchlist is updated"
      centered
      onCancel={onClose}
      footer={
        <Button type="primary" onClick={onClose}>
          Close
        </Button>
      }
    >
      <p className={styles.lead}>
        {list.length
          ? `These ${list.length} coins are now your personal watchlist. Weekly names come first. The rest are strong sentiment without high geopolitical risk.`
          : "The personal watchlist was updated."}
      </p>
      {list.length > 0 && (
        <div className={styles.chips}>
          {list.map((coin) => {
            const weekly = String(coin.reason || "").startsWith("Weekly");
            return (
              <span
                key={`${coin.symbol}-${coin.reason || ""}`}
                className={`${styles.chip} ${weekly ? styles.weekly : styles.sentiment}`}
              >
                <img
                  src={coinLogo(coin.symbol)}
                  alt=""
                  className={styles.logo}
                  onError={(event) => {
                    event.currentTarget.onerror = null;
                    event.currentTarget.src = "/placeholders/asset-logo.svg";
                  }}
                />
                <span>{coin.symbol}</span>
                {coin.reason ? <span className={styles.reason}>{coin.reason}</span> : null}
              </span>
            );
          })}
        </div>
      )}
    </Modal>
  );
}

export default WatchlistReplacedModal;
